import React from 'react';
import Leftbar from './../components/Leftbar';
import Topbar from './../components/Topbar';
import { Link } from 'react-router-dom';
import TopNav from '../components/TopNav';
import { Translate, I18n } from "react-redux-i18n";

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'

const ManageTeam = () => {
  return (
    <>
      <body id="page-top">
        <TopNav />
        <div id="wrapper">

          <Leftbar />

          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">

              <Topbar />

              <div className="container-fluid">
                <div className="row align-items-center justify-content-between mb-4">
                  <div className="col">
                    <h1 className="h3 mb-0 title-top">{I18n.t('Manage Team')}</h1>
                  </div>
                  <div className="col-auto ml-auto">
                    <div className="form-row">
                      <div className="col">
                        <Link to="/add-team-member">
                          <a className=" btn btn-primary">
                            <i className="fas fa-plus fa-sm" />{I18n.t('Team Member')} </a>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive">
                          <Table className="table align-items-center mb-0">
                            <Thead>
                              <Tr>
                                <Th>{I18n.t('S no.')}</Th>
                                <Th>{I18n.t('User')}</Th>
                                <Th>{I18n.t('Status')}</Th>
                                <Th>{I18n.t('Action')}</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              <Tr>
                                <Td>1</Td>
                                <Td>User 1 </Td>
                                <Td>Active</Td>
                                <Td>
                                  <div className>
                                    <a className="flex items-center mr-2 text-dark btn btn-sm" href>
                                      <i className="far fa-edit" /> {I18n.t('Edit')}</a>
                                    <a className="flex items-center btn btn-sm text-danger" href>
                                      <i className="far fa-trash-alt btn-outline-danger" /> {I18n.t('Delete')}</a>
                                  </div>
                                </Td>
                              </Tr>
                              <Tr>
                                <Td>2</Td>
                                <Td>User 2 </Td>
                                <Td>Active</Td>
                                <Td>
                                  <div className>
                                    <a className="flex items-center mr-2 text-dark btn btn-sm" href>
                                      <i className="far fa-edit" /> Edit</a>
                                    <a className="flex items-center btn btn-sm text-danger" href>
                                      <i className="far fa-trash-alt btn-outline-danger" /> Delete</a>
                                  </div>
                                </Td>
                              </Tr>
                              <Tr>
                                <Td>3</Td>
                                <Td>User 3</Td>
                                <Td>Active </Td>
                                <Td>
                                  <div className>
                                    <a className="flex items-center mr-2 text-dark btn btn-sm" href>
                                      <i className="far fa-edit" /> Edit</a>
                                    <a className="flex items-center btn btn-sm text-danger" href>
                                      <i className="far fa-trash-alt btn-outline-danger" /> Delete</a>
                                  </div>
                                </Td>
                              </Tr>
                              <Tr>
                                <Td>4</Td>
                                <Td>User 4 </Td>
                                <Td>Active</Td>
                                <Td>
                                  <div className>
                                    <a className="flex items-center mr-2 text-dark btn btn-sm" href>
                                      <i className="far fa-edit" /> Edit</a>
                                    <a className="flex items-center btn btn-sm text-danger" href>
                                      <i className="far fa-trash-alt btn-outline-danger" /> Delete</a>
                                  </div>
                                </Td>
                              </Tr>
                            </Tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  )
}
export default ManageTeam;